
import { Link, NavLink, useLocation } from "react-router-dom"
import logo from "../assets/images/Logo.svg"
import logoBlue from "../assets/images/logoBlue.svg"
export function Navbar() {
    var location = useLocation()
    // console.log(location.pathname);
    return(
        <>
        <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
            <NavLink className="navbar-brand" to="/">
                {location.pathname == "/" ?
                <img className="img-fluid" src={logo} alt="logo" />
                :
                <img className="img-fluid" src={logoBlue} alt="logo" />
                }
            </NavLink>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <i class="fas fa-bars"></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">
                    <NavLink className="nav-link active" aria-current="page" to="/">Home</NavLink>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="#">Commercial</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="#">Residential</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" href="#">Projects</a>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to="/about">About Us</NavLink>
                </li>
                </ul>
                {location.pathname == "/" ?
               <Link to="/contact" className="whiteBtn" type="submit">Contact Us</Link>
               :
               <Link to="/contact" className="blueBtn" type="submit">Contact Us</Link>
                }
            </div>
            </div>
        </nav>
        </>
    )
}